module.exports = require("remarkable");


//////////////////
// WEBPACK FOOTER
// external "remarkable"
// module id = 616
// module chunks = 0